function PieEchartOpComm () {
  return {
    color: ['#9761e7', '#3da1ff', '#38ccca', '#4ac871', '#fbd538', '#f2637a'],
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      x: '45%',
      y: 'center',
      icon: 'circle',
      formatter: function (name) {
        var arr = [
          `{b|${name}}`
        ]
        return arr.join('\n')
      },
      textStyle: {
        rich: {
          b: {
            fontSize: 12,
            color: 'white'
          }
        },
        width: 50,
        ellipsis: 'truncate',
        overflow: 'truncate'
      }
    },
    series: [
      {
        name: '代理商贡献占比',
        type: 'pie',
        radius: ['45%', '65%'],
        data: [],
        label: {
          position: 'inside',
          formatter: '{d}%',
          textStyle: {
            color: 'white'
          },
          show: false
        },
        labelLine: {
          show: false
        },
        center: ['21%', '50%']
      }
    ]
  }
}

export function contributionProportionEchartOp ({ v, data }) {
  let options = PieEchartOpComm({ v })
  let seriesData = []
  let legendNames = data.map(item => {
    seriesData.push({
      value: item.percent,
      name: item.source
    })

    return item.source
  })
  options.series[0].data = seriesData
  options.series[0].radius = ['0%', '80%']
  options.series[0].center = ['50%', '50%']
  options.series[0].label.show = true
  options.legend.data = legendNames
  options.legend.x = '70%'
  options.color = ['#ff974c', '#4a6fe2', '#e65a56']
  return options
}
export function customerContributionEchartOp ({ v, data }) {
  let options = PieEchartOpComm({ v })
  let seriesData = []
  let legendNames = data.sort((a, b) => b.totalPay - a.totalPay).map(item => {
    seriesData.push({
      value: item.totalPay,
      name: item.name
    })

    return item.name
  })
  options.legend.height = 100
  options.series[0].data = seriesData
  // options.legend.data = legendNames
  return options
}
export function brandContributionEchartOp ({ v, data }) {
  let options = PieEchartOpComm({ v })
  let seriesData = []
  let legendNames = data.sort((a, b) => b.totalPay - a.totalPay).map(item => {
    seriesData.push({
      value: item.totalPay,
      name: item.name
    })

    return item.name
  })
  options.series[0].data = seriesData
  // options.legend.data = legendNames
  return options
}
export function tradeContributionEchartOp ({ v, data }) {
  let options = PieEchartOpComm({ v })
  let seriesData = []
  let legendNames = data.sort((a, b) => b.totalPay - a.totalPay).map(item => {
    seriesData.push({
      value: item.totalPay,
      name: item.name
    })

    return item.name
  })
  options.series[0].data = seriesData
  // console.log(legendNames)
  // options.legend.data = legendNames
  // options.legend.height = 200
  // options.legend.textStyle.width = 200
  return options
}
